import classNames from 'classnames';

import { SectionTitle } from '@/ui/index';
import { Cup } from '@/icons/index';

import styles from './Awards.module.scss';

const Awards = ({ data }) => {
  const renderAwardsItem = (item, index) => {
    return (
      <li className={styles['awards-element']} key={index}>
        <div
          className={styles['awards-element__icon']}
          data-testid='award-icon'
        >
          <Cup />
        </div>
        <span className={styles['awards-element__text']}>{item.text}</span>
      </li>
    );
  };

  const renderAwardsRow = (item, index) => {
    return (
      <div className={styles['awards-item']} key={index}>
        {item?.year && (
          <div className={styles.year}>
            <SectionTitle
              titleModify={classNames(
                styles['awards-item__year'],
                'title--medium',
              )}
            >
              {item.year}
            </SectionTitle>
          </div>
        )}
        {item?.items && (
          <ul className={styles['awards-item__list']}>
            {item.items.map(renderAwardsItem)}
          </ul>
        )}
      </div>
    );
  };

  return (
    <section className={classNames('wrapper', 'section', styles.custom)}>
      {data?.title && (
        <SectionTitle
          titleModify={classNames([styles.awards__title, 'title--large'])}
        >
          {data.title}
        </SectionTitle>
      )}
      {data?.years && (
        <div className={styles.awards__inner}>
          {data.years.map(renderAwardsRow).sort((a, b) => b.year - a.year)}
        </div>
      )}
    </section>
  );
};

export default Awards;
